// src/components/Navbar.js
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = ({ currentLang, changeLang }) => {
  const { t } = useTranslation();

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow-sm">
      <div className="container">
        <Link className="navbar-brand fw-bold" to="/">
          <span className="text-primary">Alpha</span>PremiumSolutions
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-lg-2">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                {t("nav.home")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/services">
                {t("nav.services")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                {t("nav.about")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                {t("nav.contact")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/login">
                {t("nav.login")}
              </Link>
            </li>
          </ul>

          <div className="d-flex align-items-center gap-3 ms-lg-3">
            <select
              className="form-select form-select-sm bg-dark text-light border-light"
              style={{ width: "80px" }}
              value={currentLang}
              onChange={(e) => changeLang(e.target.value)}
            >
              <option value="sr">SRB</option>
              <option value="en">ENG</option>
              <option value="de">DE</option>
            </select>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;